import React from "react";
import { commonStyles } from "../../theme/commonStyles";
import { themeService } from "../../theme/service/activeTheme.service";
import { languageService } from "../../Language/language.service";
import SvgIcon from "react-icons-kit";
import { ic_arrow_back } from "react-icons-kit/md/ic_arrow_back";
import { circle } from "react-icons-kit/fa/circle";
import { CRUDFunction } from "../../reduxCURD/container";
import { Col, Row, Tooltip } from "reactstrap";
import { updateUserTeams, userListRequest } from "../../reduxRelated/actions/userActions";
import { locationListStyle } from "../LocationSetup/LocationListStyle";
import { plus } from "react-icons-kit/icomoon/plus";
import permissionCheck from "../../utils/permissionCheck";
import { ButtonActionsTable } from "../Common/Buttons";
import ThisTable from "../Common/ThisTable";
import { guid } from "../../utils/UUID";
import CustomForm from "../../libraries/form";
import TeamMemberSelector from "./TeamMemberSelector";
import { InputField, LabelWithFieldWrapper } from "../SetupPage/GITestAssetTypes/AddTestsForm";
import { GITestStyle } from "../SetupPage/GITestAssetTypes/style/GITestStyle";
import { ButtonStyle } from "../../style/basic/commonControls";
import { MyButton } from "../Common/Forms/formsMiscItems";

class Teams extends React.Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      selectedTeam: null, // holds the selected team for details
      mode: "",
      teamForm: null,
      validationFailure: "",
    };
    this.state = { teams: [], ...this.defaultState };

    this.columns = [
      {
        Header: "#",
        id: "row",
        maxWidth: 50,
        filterable: false,
        Cell: (row) => {
          return <div style={{ textAlign: "center" }}>{row.index + 1}</div>;
        },
      },
      {
        Header: languageService("Name"),
        id: "name",
        accessor: (d) => {
          return <div style={{ textAlign: "center" }}>{d.name} </div>;
        },
        minWidth: 120,
      },
      {
        Header: languageService("Members"),
        id: "members",
        show: this.props.viewMode ? false : true,
        accessor: (d) => {
          return <div style={{ textAlign: "center" }}>{d.membersCount ? d.membersCount : "-"} </div>;
        },
        minWidth: 80,
      },
      {
        Header: languageService("Actions"),
        id: "actions",
        accessor: (d) => {
          return (
            <div>
              {permissionCheck("TEAM", "view") && (
                <ButtonActionsTable
                  handleClick={(e) => this.handleSelectedClick(d)}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Select")}
                />
              )}
              {permissionCheck("TEAM", "delete") && (
                <ButtonActionsTable
                  handleClick={(e) => {
                    if (window.confirm("Are you sure you want to delete this team?")) {
                      this.handleDeleteTeam(d);
                    }
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Delete")}
                />
              )}
            </div>
          );
        },
        minWidth: 150,
      },
    ];

    this.handleDeleteTeam = this.handleDeleteTeam.bind(this);
    this.handleSelectedClick = this.handleSelectedClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.defaultNewTeam = { users: [], name: "" };
  }

  componentDidMount() {
    this.props.userListRequest();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.userActionType === "USER_LIST_SUCCESS" && this.props.userActionType !== prevProps.userActionType) {
      const teams = this.deriveTeamsFromUsers(this.props.userList);
      this.setState({ ...this.defaultState, teams: teams });
    }
    if (this.props.userActionType === "UPDATE_TEAM_SUCCESS" && this.props.userActionType !== prevProps.userActionType) {
      this.props.userListRequest();
    }
  }

  deriveTeamsFromUsers = (userList) => {
    const teamsMap = new Map();
    userList.forEach((user) => {
      user.teams &&
        user.teams.forEach((team) => {
          if (!teamsMap.has(team.id)) {
            teamsMap.set(team.id, { id: team.id, name: team.name, membersCount: 0, users: [user._id] });
          }
          teamsMap.get(team.id).membersCount += 1;
          teamsMap.get(team.id).users.push(user._id);
        });
    });
    return Array.from(teamsMap.values());
  };

  handleDeleteTeam = (team) => {
    this.props.updateUserTeams({ ...team, users: [] });
  };

  handleSelectedClick(d) {
    this.setState({ selectedTeam: d, mode: "Edit", teamForm: { ...d } });
  }
  handleSubmit = () => {
    let validationFail = calculateValid(this.state.teamForm);
    if (validationFail) {
      this.setState({ validationFail: validationFail });
      return;
    }
    // prepare team update user and send to server
    let newTeam = { ...this.state.teamForm };
    if (this.state.mode === "Add") newTeam.id = guid();
    else if (this.state.selectedTeam) newTeam.id = this.state.selectedTeam.id;
    this.props.updateUserTeams(newTeam);
    this.setState({ ...this.defaultState });
  };
  render() {
    const { teams, selectedTeam, mode } = this.state;
    const { validationFail } = this.state;
    return (
      <Col md={12}>
        <Row style={themeService(commonStyles.pageBorderRowStyle)}>
          {/*  View Teams List 
           TEAMS (LEFT SECTION)
        - Teams List load with editable this table
        - Team should have name, Members (member count should not be edited)
        - Action to manage / remove team (selected team )
        - Add button on top to add another row in team (create new team) , save it or cancel , set name of team in EDITABLE Table to be used.        
        
            TEAM Detail (RIGHT SECTION) selected team
        - Show name,
        - Show list of members.
        - add more users in list
        - remove existing users
        */}

          <Col md={6}>
            <Row>
              <Col md={4}>
                <h3>{languageService("Teams")}</h3>
              </Col>
              <Col md={8}>
                {!mode && <AddSign handleAddTeam={() => this.setState({ mode: "Add", teamForm: { ...this.defaultNewTeam } })} />}
              </Col>
            </Row>
            <ThisTable
              showFilters={false}
              tableColumns={this.columns}
              tableData={teams}
              pageSize={50}
              minRows={10}
              page={0}
              height={"auto"}
              // onClickSelect
            />
          </Col>
          <Col md={6}>
            {mode && (
              <React.Fragment>
                <h3>{mode == "Add" ? languageService("Add New Team") : selectedTeam && selectedTeam.name}</h3>
                <div className="card">
                  <div className="card-body">
                    <LabelWithFieldWrapper label={languageService("Name")} lblStyle={{ width: "75px" }}>
                      <InputField
                        inputFieldProps={{ name: "name", type: "text" }}
                        changeHandler={(e) => {
                          this.setState({ teamForm: { ...this.state.teamForm, [e.target.name]: e.target.value } });
                        }}
                        value={this.state.teamForm && this.state.teamForm.name}
                      />
                    </LabelWithFieldWrapper>
                    <LabelWithFieldWrapper label={languageService("Members")} lblStyle={{ width: "75px" }} />
                    <TeamMemberSelector
                      users={this.props.userList}
                      teamForm={this.state.teamForm}
                      handleFieldChange={(field, value) => {
                        this.setState({ teamForm: { ...this.state.teamForm, [field]: value } });
                      }}
                    />
                  </div>
                  <div className="card-footer" style={{ textAlign: "right" }}>
                    {validationFail && (
                      <span style={{ fontSize: "12px", color: "red", paddingRight: "10px" }}>{languageService(validationFail)}</span>
                    )}
                    <MyButton
                      onClick={(e) => {
                        this.handleSubmit();
                      }}
                      type="submit"
                      style={{ ...themeService(ButtonStyle.commonButton), ...{ marginRight: "10px" } }}
                    >
                      {this.props.mode == "Add" ? languageService("Create") : languageService("Update")}
                    </MyButton>
                    <MyButton
                      onClick={(e) => {
                        this.setState({ mode: null, selectedTeam: null, teamForm: { ...this.defaultNewTeam }, validationFail: "" });
                      }}
                      type="submit"
                      style={themeService(ButtonStyle.commonButton)}
                    >
                      {languageService("Cancel")}
                    </MyButton>
                  </div>
                </div>
              </React.Fragment>
            )}
          </Col>
        </Row>
      </Col>
    );
  }
}

let variables = {
  userReducer: {
    userList: [],
  },
};

let actionOptions = {
  create: true,
  update: false,
  read: false,
  delete: false,
  others: { userListRequest, updateUserTeams },
};
let TeamsContainer = CRUDFunction(Teams, "teamManager", actionOptions, variables, ["userReducer"]);
export default TeamsContainer;

class AddSign extends React.Component {
  state = {
    tooltip: false,
  };

  render() {
    return (
      <React.Fragment>
        {permissionCheck("TEAM", "create") && (
          <div>
            <div style={themeService(locationListStyle.addNewField)} onClick={this.props.handleAddTeam}>
              <SvgIcon id={"add_Teams"} style={themeService(locationListStyle.addIconStyle)} icon={plus} size="15" />
            </div>
            <Tooltip isOpen={this.state.tooltip} target={`add_Teams`} toggle={() => this.setState({ tooltip: !this.state.tooltip })}>
              {languageService("Add")}
            </Tooltip>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const calculateValid = (teamForm) => {
  if (!teamForm) return "";
  if (teamForm.users && teamForm.users.length === 0) return "Member list can not be empty";
  if (!teamForm.name) return "Name can not be empty";
};



// WEBPACK FOOTER //
// ./src/components/OrgTeams/index.jsx